import { Download as DownloadIcon } from '@mui/icons-material';
import { Button, ButtonProps, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { auditDownloadAudio } from '../../actions';

interface Props extends Omit<ButtonProps, 'onClick'> {
  readonly stationId: string;
  readonly audioId: string;
}

export function DownloadAudioBtn(p: Props) {
  const { stationId, audioId, ...rest } = p;

  return (
    <Tooltip
      title={
        <FormattedMessage id="audit.audiosScreen.downloadBtn" defaultMessage="Descargar archivo" />
      }
    >
      <Button
        startIcon={<DownloadIcon />}
        onClick={() =>
          auditDownloadAudio({
            stationId,
            customId: audioId,
          })
        }
        {...rest}
      />
    </Tooltip>
  );
}
